import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiConfigs } from "../../constants/apiConfigs";
import { WalletData } from "../../types/wallet/WalletTypes";
import { isFresh } from "../../utils/helpers";
import { ERROR } from "../../constants/errors";
import { fetchWallet } from "../../services/api/wallet";

export interface WalletSlice extends WalletData {
    last_fetched_at: number | null
    expired: boolean,
    loading: boolean
}

export const initialState: WalletSlice = {
    payout_account: null,
    payouts: [],
    statistics: null,
    transactions: [],
    last_fetched_at: null,
    expired: false,
    loading: false,
    pan: {
        available: false,
        required: true
    }
}

const STALE_TIME = apiConfigs.FETCH_WALLET.staleTime;

export const fetchWalletData = createAsyncThunk(
    'wallet/fetch',
    async (force: boolean, {getState, rejectWithValue}) => {
        const state = getState() as {wallet: WalletSlice};
        if(!force && isFresh(state.wallet.last_fetched_at, STALE_TIME) && !state.wallet.expired){
            return rejectWithValue(ERROR.CACHED);
        }

        try {
            const walletData = await fetchWallet();
            return walletData;
        } catch (error: any) {
            return rejectWithValue(ERROR.NOT_FOUND);
        }

    }
)

const walletSlice = createSlice({
    name: 'wallet',
    initialState,
    reducers: {
        markExpired: (state) => {
            state.expired = true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchWalletData.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchWalletData.fulfilled, (state, data) => {
                state.loading = false;
                state.last_fetched_at = Date.now();
                state.payout_account = data.payload.payout_account;
                state.statistics = data.payload.statistics;
                state.payouts = data.payload.payouts;
                state.transactions = data.payload.transactions;
                state.pan = data.payload.pan ?? {available: false, required: true}
                state.expired = false;
            })
            .addCase(fetchWalletData.rejected, (state, data) => {
                state.loading = false;
            })
    }
})

export const {markExpired} = walletSlice.actions;

export default walletSlice.reducer;